import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { SearchTrayComponent } from "../UI/SearchTrayComponent";
import { PartCardComponent } from "./PartCard/PartCardComponent";

interface IProps {
    pageTitle:string;
}

interface IState {
    chosen:string;
}

export class PartsComponent extends React.Component<IProps, IState> {
    
    constructor(props:IProps) {
        super(props);
        this.state={chosen:''};
    }

    selectCallback=(selectedText:string) => {
        this.setState({chosen:selectedText});
    }

    render() {
        let searchList = ["Part #1","Part #2","Part #3","Part #4","Part #5","Part #6"];
        let hasChosen = this.state.chosen.length > 0;
        let title = this.state.chosen.length > 0?this.state.chosen : "Please select an item"
        return(
            <Grid item container direction={'row'} spacing={0}>
                <SearchTrayComponent trayTitle={''} searchList={searchList} selectCallback={this.selectCallback}/>
                <Grid item container xs>
                    { hasChosen && (
                        <PartCardComponent title={title} />
                    )}
                    { !hasChosen && (
                        <Typography variant='h4'>
                            {title}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        )
    }
}